@if (field$ | async; as field) {
  @if (option$ | async; as option) {
    @if (field.isSwitcher) {
      <app-radio-button [allowToggle]="true" [ngModel]="option.isChecked">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      </app-radio-button>
    } @else {
      <app-checkbox [ngModel]="option.isChecked">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      </app-checkbox>
    }

    <ng-template #labelTemplate>
      <div class="flex items-center gap-x-2">
        @if (option.icon) {
          <span class="flex">
            <ng-container
              *ngTemplateOutlet="iconTemplate; context: { src: option.icon, value: option.value }"
            ></ng-container>
          </span>
        }

        <span data-test-id="filter-option-label" class="filter-option-label">
          <span
            title="{{ getValueToTranslate() | translate }}"
            data-test-id="filter-option-label-text"
            class="pr-1 text"
          >
            {{ getValueToTranslate() | translate }}
          </span>
          <span class="option-count">({{ optionDataCount$ | async }})</span>
        </span>

        @if (option?.tooltipTranslationKey) {
          <app-info-icon
            class="flex justify-center items-center"
            [tooltipText]="tooltipTemplate"
            [tooltipPosition]="'top'"
          ></app-info-icon>
        }
      </div>
    </ng-template>

    <ng-template #iconTemplate let-src="src">
      @if (src) {
        <svg-icon preserveAspectRatio="none" [stretch]="true" [src]="src"></svg-icon>
      }
    </ng-template>

    <ng-template #tooltipTemplate>
      <span class="w-44">{{ option?.tooltipTranslationKey | translate }}</span>
    </ng-template>
  }
}
